module.exports = __webpack_public_path__ + "static/media/Privacy Policy-05_26_2020-6.b0d379c2.png";